import Skeleton, {SkeletonProps} from 'react-loading-skeleton';
import {useTheme} from '@components/theme/useTheme';

export function useSkeletonColors() {
    const theme = useTheme();
    return theme === 'light'
        ? {
              baseColor: 'var(--color-neutral-200)',
              highlightColor: 'var(--color-neutral-100)',
          }
        : {
              baseColor: 'var(--color-neutral-800)',
              highlightColor: 'var(--color-neutral-700)',
          };
}

export const ThemeAwareSkeleton = (props: SkeletonProps) => {
    const {baseColor, highlightColor} = useSkeletonColors();
    return (
        <Skeleton
            {...props}
            baseColor={props.baseColor ?? baseColor}
            highlightColor={props.highlightColor ?? highlightColor}
        />
    );
};
